export const RESPONSIVE_AMPLIENCE_IMAGE_WIDTHS: number[] = [300, 500, 700, 900, 1100];

export const getAmplienceImageSrcSet = (
  imageUrl: URL,
  widths: number[] = RESPONSIVE_AMPLIENCE_IMAGE_WIDTHS
) => {
  return widths
    .map((width) => {
      imageUrl.searchParams.set('w', width.toString());
      return `${imageUrl.toString()} ${width}w`;
    })
    .join(', ');
};

/**
 * Converts an Amplience aspect ratio (`16:9`) into a CSS `aspect-ratio` value (`16 / 9`),
 * so the image reserves its layout box before the bytes arrive.
 */
export const getCssAspectRatio = (aspectRatio?: `${number}:${number}`) =>
  aspectRatio?.replace(':', ' / ');
